import React from "react";
import RecentHotelBooking from "./RecentHotelBooking";
import RecentTourBooking from "./RecentTourBooking";

const RecentBookings = ({ TableData }) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      <RecentHotelBooking TableData={TableData} />
      <RecentTourBooking TableData={TableData} />
    </div>
  );
};

export default RecentBookings;
